import {createSelector} from 'reselect';

const getFeedConfigState = (state) => state.dashboard.feedConfig;

export const getFilter = createSelector([getFeedConfigState], (feedConfigState) => {
    return feedConfigState.filter;
});
